import React from "react";

//styles
import "./ProgressBar.scoped.scss";

const ProgressBar = ({ max = 100, value = 0, completedColor, style = {}, ...props }) => {
	return (
		<div className="progress_bar" style={style}>
			<div className="completed" style={{ width: `${value * (max / 100)}%`, backgroundColor: completedColor }}>
				{props.children}
			</div>
		</div>
	);
};

export default ProgressBar;
